import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Child, LastResults, MultipleChildResult } from '@isophi/pap-api';
import { RouterLinkFactory } from '../../../core/router/router-link.factory';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NavigationComponent {
  @Input() results: LastResults;

  @Input() selectedChild: Child;

  @Input() teachersResults: MultipleChildResult[];

  @Input() selectedResult: MultipleChildResult;

  @Input() papLocked = false;

  constructor(public routerLinkFactory: RouterLinkFactory) {}

  get hasResults(): boolean {
    return this.isChildSelected && this.hasSelectedChildResults;
  }

  get isChildSelected(): boolean {
    return this.selectedChild !== null;
  }

  get hasSelectedChildResults(): boolean {
    return true; // return hasAnyResult(this.results);
  }

  sidebarClose() {
    document.querySelector('.app')?.classList.remove('sidenav-toggled');
  }
}
